import {
  formatCalendarDate,
  formatCalendarDateForInput,
  getLocalCalendarDate,
} from "./calendarDate.mjs";

// Timestamps describe an instant; show its day in the viewer's timezone.
export function formatTimestampDateForInput(value) {
  if (!value) return "";
  // Keep day-only values stable while older endpoints are being migrated.
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
    return formatCalendarDateForInput(value);
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? "" : getLocalCalendarDate(date);
}

export function formatTimestampDate(value) {
  return formatCalendarDate(formatTimestampDateForInput(value));
}
